import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import { rqtPostProductNetValueChatList } from '@/services/wms/product';
import { Chart } from '@antv/g2';
let chart = null;
export default {
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt
  },
  data() {
    return {
      title: '',
      searchForm: {
        productId: undefined,
        type: ''
      },
      listRequest: rqtPostProductNetValueChatList,
      menu: {
        curItem: {},
        showMenu: false,
        menuItems: [{
          name: '今年',
          type: '01'
        }, {
          name: '最近一年',
          type: '02'
        }, {
          name: '最近两年',
          type: '03'
        }, {
          name: '最近三年',
          type: '04'
        }, {
          name: '最近五年',
          type: '05'
        }]
      }
    };
  },
  mounted() {
    let item = this.$route.query && this.$route.query.item;
    if (item) {
      item = JSON.parse(item);
      this.menu.curItem = this.menu.menuItems[0];
      this.searchForm.productId = item.productId;
      this.title = item.productName;
      this.renderChart([]);
      this.fetchData();
    }
  },
  unmounted() {
    chart = null;
  },
  methods: {
    onMenuClick() {
      this.menu.showMenu = true;
    },
    onMenuSelect(item) {
      this.menu.curItem = item;
      this.menu.showMenu = false;
      this.fetchData();
    },
    fetchData() {
      this.searchForm.type = this.menu.curItem.type;
      this.$refs['ListViewCpt'].initListData();
    },
    renderChart(data) {
      if (!chart) {
        chart = new Chart({
          container: 'chart',
          autoFit: true,
          height: 300
        });
        chart.data(data);
        chart.scale({
          netValue: {
            alias: '单位净值',
            min: 1,
            nice: true
          },
          accumulateNetValue: {
            alias: '累计净值',
            min: 1,
            nice: true
          }
        });
        chart.tooltip({
          showCrosshairs: true,
          shared: true
        });
        chart.axis('netValue', {
          title: {}
        });
        chart.axis('accumulateNetValue', {
          title: {}
        });
        chart.legend({
          custom: true,
          items: [{
            name: '单位净值',
            value: 'netValue',
            marker: {
              symbol: 'line',
              style: {
                stroke: '#1890ff',
                lineWidth: 2
              }
            }
          }, {
            name: '累计净值',
            value: 'accumulateNetValue',
            marker: {
              symbol: 'line',
              style: {
                stroke: '#2fc25b',
                lineWidth: 2
              }
            }
          }]
        });
        chart.line().position('publicDate*netValue').color('#1890ff');
        chart.point().position('publicDate*netValue').color('#1890ff');
        chart.line().position('publicDate*accumulateNetValue').color('#2fc25b');
        chart.point().position('publicDate*accumulateNetValue').color('#2fc25b');
        chart.removeInteraction('legend-filter');
        chart.render();
      } else {
        chart.changeData(data);
      }
    },
    onListDataChange(list) {
      this.renderChart(list);
    }
  }
};